module.exports = __webpack_public_path__ + "static/media/profile-background.dc4bb868.jpg";